module["exports"] = [
  "Livros",
  "Filmes",
  "Música",
  "Jogos",
  "Electrónica",
  "Computadores",
  "Casa",
  "Jardim",
  "Ferramentas",
  "Mercearia",
  "Saúde",
  "Beleza",
  "Brinquedos",
  "Crianças",
  "Bebé",
  "Roupas",
  "Sapatos",
  "Jóias",
  "Desporto",
  "Ar Livre",
  "Automóveis",
  "Industrial"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_PT/commerce/department.js
// module id = 3446
// module chunks = 1610